import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_RegulationList_ActionsMenu_ApiEnum {
    'create_regulation' = 'create_regulation',
}

export enum Config_RegulationList_Modules_ApiEnum {
    'results' = 'results',
}

export enum Config_RegulationList_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RegulationList_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RegulationList_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_RegulationList_ApiInterface
    extends ConfigDataInterface<
        Config_RegulationList_Modules_ApiEnum,
        Config_RegulationList_ActionsMenu_ApiEnum,
        Config_RegulationList_ActionsOther_ApiEnum,
        Config_RegulationList_PageMenu_ApiEnum,
        Config_RegulationList_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
